module.exports=function(scope){ return `# Call /match-3d-3d or /match-3d-2d or /match-2d-2d based on data you are matching
# The source object must have EITHER an enrollmentIdentifier or faceMap parameter or image parameter
# The target object must have EITHER an enrollmentIdentifier or faceMap parameter or image parameter

curl -X POST \
'https://your.internal.zoomserver.instance.url/match-3d-3d' \
-H 'Content-Type: application/json' \
-H 'X-User-Agent: INSERT_X_USER_AGENT_VALUE_HERE' \
-d '{
    "source": {
        "faceMap": "INSERT_FACEMAP_DATA_AS_BASE64_HERE"
    },
    "target": {
        "faceMap": "INSERT_FACEMAP_DATA_AS_BASE64_HERE"
    }
}'
`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/bash/compare.bash.tpl